import { render, staticRenderFns } from "./vistaListado.vue?vue&type=template&id=d58a71f8&scoped=true"
import script from "./vistaListado.vue?vue&type=script&lang=js"
export * from "./vistaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58a71f8",
  null
  
)

export default component.exports